<template>
    <van-dialog
        v-model="show"
        :confirm-button-text="$t('changeChannel.confirmButtonText')"
        :cancel-button-text="$t('changeChannel.cancelButtonText')"
        showCancelButton
        messageAlign="left"
        width="75%"
        :before-close="onBeforeClose"
    >
        <template #title>
            <div class="header">
                <img src="@/assets/images/openAccount/icon_popup_close.png" class="close" @click="onClose" />
                <div class="title">{{ $t('changeChannel.title') }}</div>
            </div>
        </template>
        <div class="dialog-content">
            <span>{{ $t('changeChannel.content1') }}</span>
            <span class="code">{{ linkCodeStr }}</span>
            <span>{{ $t('changeChannel.content2') }}</span>
            <span class="code">{{ userCodeStr }}</span>
            <span>{{ $t('changeChannel.content3') }}</span>
            <span class="code">{{ linkCodeStr }}</span>
            <span>{{ $t('changeChannel.content4') }}</span>
        </div>
    </van-dialog>
</template>

<script>
import { customizeRequest, ApplyUpdate } from '@/apis/openAccount'
import { mapActions } from 'vuex'
import { Toast } from 'vant'
import { i18n } from '@/i18n/openAccount'

export default {
    components: {},
    props: {},
    data() {
        return {
            show: false,
            aeCode: '',
            channel: '',
            linkAeCode: '',
            linkChannel: '',
        }
    },
    computed: {
        linkCodeStr() {
            return [this.linkAeCode, this.linkChannel].filter(el => !!el).join('-')
        },

        userCodeStr() {
            return [this.aeCode, this.channel].filter(el => !!el).join('-')
        },
    },
    watch: {},
    methods: {
        ...mapActions('account', ['submitApply']),
        $t: v => i18n.t(v),
        onClose() {
            this.show = false
            this.linkCode = ''
            this.userCode = ''
        },

        async onBeforeClose(action, done) {
            if (action === 'confirm') {
                await customizeRequest(
                    async () => {
                        return ApplyUpdate(
                            {
                                aeCode: this.linkAeCode,
                                channel: this.linkChannel,
                            },
                            false,
                            'CHANNEL'
                        )
                    },
                    () => {
                        done()
                        this.submitApply()
                    },
                    {
                        errorHandler(res) {
                            done(false)
                            let { message } = res?.data?.error || {}
                            const { code } = res?.data?.error || {}

                            // 渠道错误
                            if (code === 151212) {
                                message = i18n.t('changeChannel.incorrectChannel')
                            }

                            Toast({
                                message,
                                duration: 3000,
                                closeOnClick: true,
                            })
                        },
                    }
                )
            } else {
                done()
                // 不修改aecode，直接提交开户申请
                this.submitApply()
            }
        },
    },
}
</script>
<style scoped lang="less">
.header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;

    .close {
        position: absolute;
        top: 20px;
        right: 16px;
        width: 16px;
        height: 16px;
    }

    .title {
        color: #181818;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
    }
}

.dialog-content {
    padding: 0 16px 28px;
    font-weight: 400;
    font-size: 0;
    line-height: 20px;
    text-align: left;
    word-break: break-all;

    span {
        font-size: 14px;
    }

    .code {
        color: #043799;
    }
}
</style>
